import { render } from "./PayslipsPage.vue?vue&type=template&id=1735af3d&scoped=true"
import script from "./PayslipsPage.vue?vue&type=script&lang=js"
export * from "./PayslipsPage.vue?vue&type=script&lang=js"

import "./PayslipsPage.vue?vue&type=style&index=0&id=1735af3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1735af3d"]])

export default __exports__